module.exports = __webpack_public_path__ + "images/pop-star-df7d3c804517c1f6aa3f732e073c4870.png";